import { Typography } from '@mui/material';
import { ReactNode } from 'react';

interface HeaderTextProps {
  children: ReactNode;
}

export default function HeaderText({ children }: HeaderTextProps) {
  return (
    <Typography
      sx={{
        fontWeight: 'bold',
        fontSize: { xs: 32, sm: 40, md: 48 },
        lineHeight: '120%',
        textAlign: 'center',
        mb: 4
      }}
    >
      {children}
    </Typography>
  );
}
